// extracted by mini-css-extract-plugin
module.exports = {"limit-box":"_2wCCMsTKra","page-title":"_3Z3FKLkVEV","table-p":"_2dU6ferjMo"};